import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Inject,
  DOCUMENT
} from '@angular/core';
import { NgClass } from '@angular/common';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { TranslateDirective } from '@ngx-translate/core';

import { ButtonComponent } from '../../components/button/button.component';
import { IconComponent } from '../../components/icon/icon.component';
import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { HelpArticleIndexComponent } from './help-article-index.component';
import { HelpDesktopArticleComponent } from './help-desktop-article.component';
import { HelpScrollerDirective } from './help-scroller.directive';
import { HelpService } from './help.service';
import { HelpBaseComponent } from './help-base.component';
import { ImageLoadDirective } from './image-load.directive';

@Component({
  selector: 'td-wb-help-desktop',
  templateUrl: 'help-desktop.component.html',
  styleUrls: ['help-common.scss', 'help-desktop.component.scss'],
  imports: [
    ButtonComponent,
    TranslatePipe,
    TranslateDirective,
    IconComponent,
    NgClass,
    HelpScrollerDirective,
    HelpArticleIndexComponent,
    HelpDesktopArticleComponent,
    ImageLoadDirective,
    LoadingIndicatorComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpDesktopComponent extends HelpBaseComponent implements OnInit, OnDestroy {
  private static DEBOUNCE_DELAY: number = 30;

  private readonly imageLoad: Subject<void> = new Subject<void>();

  constructor(helpService: HelpService,
              changeDetectorRef: ChangeDetectorRef,
              @Inject(DOCUMENT) private document: Document) {
    super(helpService, changeDetectorRef);
  }

  skipToContent(articleId: string): false {
    const element = this.document.getElementById(articleId);
    if (element !== undefined && element !== null) {
      element.focus();
    }
    return false;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.imageLoad
      .pipe(
        debounceTime(HelpDesktopComponent.DEBOUNCE_DELAY),
        takeUntil(this.destroy)
      )
      .subscribe((): void => {
        this.firstLoad = true;
        this.setScrollPostion();
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onImageLoaded(): void {
    this.imageLoad.next();
  }

  hasFocus(id: string): boolean {
    return id === this.articleId;
  }
}
